import React from 'react';
import styles from './pmndp-enhanced.module.css';

const PMNDPLoader = ({ 
  type = 'modern', 
  fullscreen = false, 
  text = 'Loading...', 
  subtitle = 'Please wait while we process your request',
  size = 'medium' 
}) => {
  
  const sizeClasses = {
    small: { width: '40px', height: '40px' },
    medium: { width: '60px', height: '60px' },
    large: { width: '80px', height: '80px' }
  };

  const ModernLoader = () => (
    <div className={styles['pmndp-modern-loader']} style={sizeClasses[size]}>
      <div className={styles['pmndp-loader-ring']}></div>
      <div className={styles['pmndp-loader-ring']}></div>
      <div className={styles['pmndp-loader-ring']}></div>
      <div className={styles['pmndp-loader-dots']}>
        <div className={styles['pmndp-loader-dot']}></div>
        <div className={styles['pmndp-loader-dot']}></div>
        <div className={styles['pmndp-loader-dot']}></div>
      </div>
    </div>
  );

  const SimpleSpinner = () => (
    <div className={styles['pmndp-spinner']} style={sizeClasses[size]}></div>
  );

  const DotsLoader = () => (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      {[1, 2, 3, 4].map((i) => (
        <div
          key={i}
          style={{
            width: '12px',
            height: '12px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '50%',
            animation: `pmndp-pulse 1.4s ease-in-out ${i * 0.2}s infinite`
          }}
        />
      ))}
    </div>
  );

  const PulseLoader = () => (
    <div style={{ 
      width: sizeClasses[size].width, 
      height: sizeClasses[size].height,
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      borderRadius: '50%',
      animation: 'pmndp-pulse 2s ease-in-out infinite'
    }} />
  );

  const renderLoader = () => {
    switch (type) {
      case 'modern':
        return <ModernLoader />;
      case 'dots':
        return <DotsLoader />;
      case 'pulse':
        return <PulseLoader />;
      case 'simple':
      default:
        return <SimpleSpinner />;
    }
  };

  if (fullscreen) {
    return (
      <div className={styles['pmndp-fullscreen-loader']}>
        <div className={styles['pmndp-fullscreen-content']}>
          {renderLoader()}
          <div className={styles['pmndp-loading-text']}>{text}</div>
          <div className={styles['pmndp-loading-subtitle']}>{subtitle}</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles['pmndp-loading']}>
      {renderLoader()}
      <div className={styles['pmndp-loading-text']}>{text}</div>
      <div className={styles['pmndp-loading-subtitle']}>{subtitle}</div>
    </div>
  );
};

// Skeleton Loader Component
export const PMNDPSkeleton = ({ 
  type = 'text', 
  lines = 3, 
  width = '100%', 
  height = '16px' 
}) => {
  if (type === 'avatar') {
    return <div className={`${styles['pmndp-skeleton']} ${styles['pmndp-skeleton-avatar']}`} />;
  }

  if (type === 'title') {
    return <div className={`${styles['pmndp-skeleton']} ${styles['pmndp-skeleton-title']}`} />;
  }

  if (type === 'text') {
    return (
      <div>
        {Array.from({ length: lines }, (_, i) => (
          <div
            key={i}
            className={`${styles['pmndp-skeleton']} ${styles['pmndp-skeleton-text']}`}
            style={{
              width: i === lines - 1 ? '70%' : width,
              height: height
            }}
          />
        ))}
      </div>
    );
  }

  return (
    <div
      className={styles['pmndp-skeleton']}
      style={{ width, height }}
    />
  );
};

// Table Skeleton Loader
export const PMNDPTableSkeleton = ({ rows = 5, columns = 4 }) => (
  <div style={{ padding: '20px' }}>
    {Array.from({ length: rows }, (_, rowIndex) => (
      <div
        key={rowIndex}
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: '15px',
          marginBottom: '15px',
          padding: '15px',
          background: '#f8fafc',
          borderRadius: '8px'
        }}
      >
        {Array.from({ length: columns }, (_, colIndex) => (
          <PMNDPSkeleton
            key={colIndex}
            width="100%"
            height="20px"
          />
        ))}
      </div>
    ))}
  </div>
);

export default PMNDPLoader;
